// ============================================================================
// GOMORY-HU TREE - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'gomory-hu-tree',
  name: 'Gomory-Hu Tree',
  category: 'Graphs',
  complexity: {
    time: 'O(V³)',
    space: 'O(V²)'
  },
  description: 'A compact representation of all-pairs minimum cuts in an undirected graph. It is a weighted tree where the minimum cut between any two vertices in the original graph equals the minimum edge weight on the path between them in the tree.'
};
